import React from "react";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";
import TimeSheetCard from "./components/TimeSheetCard";

const TimeSheetReporting = ({ dataArray }) => {
  const { width, height } = useWindowDimensions();
  return (
    <div
      style={{
        flex: 1,

        maxHeight: height - 136,
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <TimeSheetCard />
    </div>
  );
};

export default TimeSheetReporting;
